import PropTypes from 'prop-types';
import { IoArrowForward } from 'react-icons/io5';
import { describeRecap } from '../../utils/recap';
import './ProgressRecap.css';

/**
 * What a log just accomplished, as before -> after: the reader's chapters and
 * leaderboard rank, then how much closer their church and the community are
 * to the next whole-Bible read-through. Renders nothing when nothing moved.
 */
const ProgressRecap = ({ recap }) => {
  const { stats, lines } = describeRecap(recap);
  if (stats.length === 0 && lines.length === 0) return null;

  return (
    <div className="progress-recap" data-testid="progress-recap">
      {stats.length > 0 && (
        <ul className="recap-stats">
          {stats.map(stat => (
            <li key={stat.key} className="recap-stat">
              <span className="recap-stat-label">{stat.label}</span>
              <span className="recap-stat-values">
                {stat.from && (
                  <>
                    <span className="recap-from">{stat.from}</span>
                    <IoArrowForward size={14} aria-label="to" className="recap-arrow" />
                  </>
                )}
                <span className="recap-to">{stat.to}</span>
                {stat.of && <span className="recap-of">{stat.of}</span>}
                {stat.change && <span className="recap-change">{stat.change}</span>}
              </span>
            </li>
          ))}
        </ul>
      )}
      {lines.map(line => (
        <p key={line.key} className={`recap-line ${line.highlight ? 'highlight' : ''}`}>
          {line.text}
        </p>
      ))}
    </div>
  );
};

const completionShape = PropTypes.shape({
  name: PropTypes.string,
  chaptersCloser: PropTypes.number,
  chaptersToGo: PropTypes.number,
  completed: PropTypes.bool,
  completions: PropTypes.number
});

ProgressRecap.propTypes = {
  recap: PropTypes.shape({
    reader: PropTypes.shape({ id: PropTypes.string, name: PropTypes.string }),
    chapters: PropTypes.shape({ before: PropTypes.number, after: PropTypes.number }),
    rank: PropTypes.shape({
      before: PropTypes.number,
      after: PropTypes.number,
      ofBefore: PropTypes.number,
      of: PropTypes.number
    }),
    church: completionShape,
    community: completionShape
  })
};

export default ProgressRecap;
